import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import TextInput from '@molecules/TextInput';
import { Td } from '@layout/ParticipantsTable';
import {
  updateOrganizationFieldAction,
  loadRulesRequestAction,
  updateOrganizationRequestAction,
} from '@actions/organizations';
import { setPersonField } from '@actions/conference';
import { selectOrganizationsRules } from '@selectors/organizations';
import { FormattedMessage } from 'react-intl';
import messages from './messages';
import { Dropdown } from '@atoms';

class Participant extends Component {
  static contextTypes = {
    isConferenceDeleted: PropTypes.bool,
  };

  componentWillMount() {
    this.props.loadRules();
  }

  render() {
    const {
      country,
      email,
      id,
      name,
      phoneNumber,
      timezone,
      type,
      arrayItemId,
    } = this.props;
    const { isConferenceDeleted } = this.context;
    return (
      <table style={{ width: '100%' }}>
        <tbody>
          <tr key={id}>
            <Td padding="0.7rem">
              <TextInput
                disabled
                underlined
                name="name"
                id="name"
                value={name}
                onChange={() => {}}
                className="name"
                style={{ marginTop: 0 }}
                label={<FormattedMessage {...messages.name} />}
              />
            </Td>
            <Td padding="0.7rem">
              <Dropdown
                disabled
                onChange={(value) => {}}
                options={[]}
                value={type}
                className="type-dropdown"
                label={<FormattedMessage {...messages.type} />}
              />
            </Td>
            <Td padding="0.7rem">
              <TextInput
                underlined
                name="phoneNumber"
                id="phoneNumber"
                value={phoneNumber}
                disabled={isConferenceDeleted}
                onChange={({ target: { name, value } }) => {
                  this.props.setPersonField(arrayItemId, name, value);
                }}
                className="phoneNumber"
                label={<FormattedMessage {...messages.phoneNumber} />}
              />
            </Td>
            <Td padding="0.7rem">
              <Dropdown
                disabled
                id="country"
                name="country"
                onChange={(value) => {}}
                options={[]}
                value={country}
                className="country"
                label={<FormattedMessage {...messages.country} />}
              />
            </Td>
            <Td padding="0.7rem">
              <Dropdown
                disabled
                id="timezone"
                name="timezone"
                className="activity-status"
                onChange={(value) => {}}
                options={[]}
                value={timezone}
                label={<FormattedMessage {...messages.timezone} />}
              />
            </Td>
            <Td padding="0.7rem">
              <TextInput
                disabled
                underlined
                name="email"
                id="email"
                value={email}
                onChange={() => {}}
                className="email"
                label={<FormattedMessage {...messages.email} />}
              />
            </Td>
          </tr>
        </tbody>
      </table>
    );
  }
}

Participant.propTypes = {
  country: PropTypes.string,
};

Participant.defaultProps = {};

const mapStateToProps = (state) => ({
  allRules: selectOrganizationsRules(state),
});

const mapDispatchToProps = {
  updateOrganizationField: updateOrganizationFieldAction,
  loadRules: loadRulesRequestAction,
  updateInfo: updateOrganizationRequestAction,
  setPersonField,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Participant);



// WEBPACK FOOTER //
// ./components/molecules/Participant/index.js